export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
  MaintenanceWork = 'MaintenanceWork',
  AiChat = 'AiChat',
  WebsiteShare = 'WebsiteShare',
  SquarePaymentIntegration = 'SquarePaymentIntegration',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
